import Vue from 'vue'

const BASE_AUTH_URL = 'auth'
const BASE_USER_URL = 'user'

export default {
  login(email, password) {
    const action = 'login'
    return Vue.http
      .post(`${BASE_AUTH_URL}/${action}`, { email, password })
      .then(response => {
        return response.body.token
      })
      .catch(error => {
        console.log(error)
        throw error
      })
  },
  signUp(payload) {
    const action = 'signup'
    return Vue.http
      .post(`${BASE_AUTH_URL}/${action}`, payload)
      .then(response => {
        return response.body.token
      })
      .catch(error => {
        console.log(error)
        throw error
      })
  },
  getCurrentUser() {
    const action = 'me'
    return Vue.http
      .get(`${BASE_USER_URL}/${action}`)
      .then(response => {
        return response.body
      })
      .catch(error => {
        console.log(error)
        throw error
      })
  },
  renewPassword(email) {
    const action = 'renewpassword'
    return Vue.http
      .post(`${BASE_AUTH_URL}/${action}`, { email })
      .then(response => {
        return response.body
      })
      .catch(error => {
        console.log(error)
        throw error
      })
  },
  confirmEmail(email) {
    const action = 'confirmemail'
    return Vue.http
      .post(`${BASE_AUTH_URL}/${action}`, { email })
      .then(response => {
        return response.body
      })
      .catch(error => {
        console.log(error)
        throw error
      })
  },
  acceptTermsConditions(accept) {
    const action = 'me/firstconnection'
    return Vue.http
      .post(`${BASE_USER_URL}/${action}`, { accept })
      .then(response => {
        return response.body
      })
      .catch(error => {
        console.log(error)
        throw error
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/auth.js